import React from 'react';

import MenuList from '@mui/material/MenuList'
import GrowPopper from 'cityads-v3/components/GrowPopper/GrowPopper';

export default function MenuPopper({ children, MenuListProps, ...rest }) {
  return (
    <GrowPopper {...rest}>
      <MenuList {...MenuListProps}>
        {children}
      </MenuList>
    </GrowPopper>
  );
}
